import {allPermissionsName} from '@/constants/permission-constants';

export const isAllPermission = (permissionName) => (permissionName === allPermissionsName);